// extracted by mini-css-extract-plugin
export default {"root":"AvatarTeam_root__h7hSk"};